const resolvePath = (path: string, obj: { [key: string]: any }): { [key: string]: any; } =>
	path.split('.').reduce((prev, curr) => (prev ? prev[curr] : null), obj) as any;

export default resolvePath;
